/**
 * Countdown to the live show.
 *
 * The start time comes from the section setting as "YYYY-MM-DD HH:mm" in the
 * shop's local time. Safari refuses that form with a space, so it is rewritten
 * to the ISO shape before parsing. Once the show starts the block switches to
 * the live marker instead of counting negative time.
 */
(() => {
  const nodes = document.querySelectorAll('[data-live-countdown]');
  if (!nodes.length) return;

  const parse = (value) => {
    const iso = value.trim().replace(' ', 'T');
    const date = new Date(iso.length === 16 ? `${iso}:00` : iso);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const units = (ms) => {
    const total = Math.floor(ms / 1000);
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  };

  const pad = (n) => String(n).padStart(2, '0');

  const render = (node, target) => {
    const clock = node.querySelector('[data-live-clock]');
    if (!clock) return false;

    const left = target - Date.now();
    if (left <= 0) {
      node.dataset.live = 'true';
      clock.textContent = node.dataset.liveLabel || '';
      return false;
    }

    const { days, hours, minutes, seconds } = units(left);
    clock.textContent = days > 0
      ? `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return true;
  };

  nodes.forEach((node) => {
    const target = parse(node.dataset.startsAt || '');
    if (!target) {
      node.hidden = true;
      return;
    }

    if (!render(node, target)) return;
    const timer = setInterval(() => {
      if (!render(node, target)) clearInterval(timer);
    }, 1000);
  });
})();

/**
 * The first screen is the viewport minus whatever sits above the band: the
 * sticky header, the usp bar, a cookie banner on a first visit. So the band
 * measures its own distance from the top of the document rather than trusting
 * a header height, and it measures again whenever the page reflows, because a
 * consent banner that sits in the flow for a second would otherwise leave the
 * band short by its height.
 */
(() => {
  const sections = document.querySelectorAll('.jxls-stream--tall');
  if (!sections.length) return;

  let frame = 0;
  const apply = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      sections.forEach((section) => {
        const offset = Math.round(section.getBoundingClientRect().top + window.scrollY);
        section.style.setProperty('--jxls-stream-offset', `${offset}px`);
      });
    });
  };

  apply();
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  document.addEventListener('visibilitychange', apply);

  if ('ResizeObserver' in window) {
    new ResizeObserver(apply).observe(document.body);
  }
  if ('MutationObserver' in window) {
    new MutationObserver(apply).observe(document.body, { childList: true });
  }
})();
